"use client"
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useWebSiteContext } from "@core/helpers/client/contexts/WebSiteContext";
import { is_seller_request_path } from "@/helpers/sellerRequest";
import HeaderSSR from "./Header/header.server";
import HeaderClient from "./Header/header.client";
import is_ads_path from "./Header/_isAdsPath";
import Footer from "./Footer";
import { InitialBannersProvider } from "@/contexts/InitialBanners";
import { setup_safe_back } from "@core/helpers/client/hooks/useSafeBack";
import { get_back_fallback_url } from "@/helpers/blogUrl";

// شماره‌گذاری تاریخچه برای دکمه‌های «بازگشت» با بارگذاری همین ماژول نصب می‌شود
setup_safe_back({ state_key: "__jmt_idx", get_fallback_url: get_back_fallback_url });

const strip_slash = (value = "") => value.replace(/\/+$/, "") || "/";

const LayoutMapping = ({ children, footer_widget, header_widget, pathname, banner_count = 0, initial_banners = null, ...props }) => {

    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        setHydrated(true);
    }, []);

    const current_pathname = usePathname() || pathname || "";
    const { web_route_names } = useWebSiteContext();

    const is_checkout = current_pathname.startsWith("/checkout");
    // صفحه‌ی درخواست فروشندگی طبق فیگما هدر و فوتر سایت را ندارد.
    const is_bare_page = is_checkout || is_seller_request_path(current_pathname, web_route_names);

    useEffect(() => {
        if (!is_bare_page) return;

        document.documentElement.style.setProperty("--header-height", "0px");
    }, [is_bare_page]);

    // banner_count را سرور برای مسیر لود اولیه می‌داند؛ تا ارتفاع واقعی بنر در --banner-height
    // بنشیند (همان ۴۸ پیکسل هر بنر)، محتوا با این مقدار از زیر بنر شروع می‌شود تا صفحه نپرد.
    const has_banner_slot = banner_count > 0 && !is_bare_page && !is_ads_path(current_pathname);

    // هدر مجله و سلر آکادمی SSR-safe‌اند و از سرور رندر می‌شوند؛ همان درخت hydrate می‌شود و دیگر بعد از hydration
    // کل هدر (نسخه‌ی SSR) unmount و نسخه‌ی client از نو mount نمی‌شود.
    // سلر آکادمی تا 2026-11-04 HeaderSSR (اسکلت) می‌گرفت: بنر فقط بعد از hydration ساخته می‌شد (جستجوی سلر: LCP
    // بنر با ۴٫۳ ثانیه تأخیر کشف) و جابه‌جایی هدر CLS ‏۰٫۰۵۵ در خانه و مقاله‌ها می‌داد.
    // شاپ از 2026-11-05 همین‌طور است: لینک‌های ردیف دوم (`header-main-menu-shop`) از سرور می‌آیند (helpers/menuKeys.js)
    // و با JS خاموش هم دیده می‌شوند. فقط هدر Ads هنوز تا hydration اسکلت HeaderSSR است.
    const render_client_header = hydrated || !is_ads_path(current_pathname);

    // بنرهای سرور فقط مال مسیری‌اند که سرور رندر کرده؛ بعد از ناوبری کلاینتی داده‌ی BannerProvider هسته می‌ماند
    const banners_for_path = strip_slash(current_pathname) === strip_slash(pathname) ? initial_banners : null;

    return (
        <>
            {has_banner_slot && <style>{`:root{--banner-height:${banner_count * 48}px}`}</style>}

            {is_bare_page ? null
                : render_client_header
                    ? <InitialBannersProvider value={banners_for_path}>
                        <HeaderClient {...{ widget: header_widget, pathname: current_pathname, banner_count, ...props }} />
                    </InitialBannersProvider>
                    : <HeaderSSR {...{ header_widget, pathname: current_pathname, banner_count, ...props }} />}

            {children}

            {is_bare_page ? null
                : <Footer {...{ widget: footer_widget, pathname: current_pathname, ...props }} />}
        </>
    );
}

export default LayoutMapping;
